import { Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Form, Snackbar } from "../../../layout";
import { Button, Input } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { useState } from "react";
import { ToFormData } from "../../../hooks/Method";
import { useTranslation } from "react-i18next";
import { action, controller, Server } from "../../../api/Server";

const VerifyFrgtCode = (props) => {
  const { setActiveStep, forgotVal, setForgotVal } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { ForgotMdl } = Model();
  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "success",
    msg: "",
  });
  const { values, setValues, errors, setErrors, handleInpChg } =
    UseForm(ForgotMdl);

  const validateForm = () => {
    let temp = {};
    temp.verCode = values.verCode !== "" ? "" : t("verificationCodeIsRequired");
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res !== undefined && res.status === 200) {
          setActiveStep(2);
        } else if (res !== undefined && res.status === 204) {
          setErrors({
            ...errors,
            verCode: res.msg,
          });
        }
      };
      values.forgotStep = 2;
      Server(controller.Auth + action.Forgot).post(
        ToFormData(values),
        onComplete
      );
    }
  };

  const handleResend = () => {
    setLoading(true);
    const onComplete = (res) => {
      setLoading(false);
      res.status === 200
        ? setSnackbar((j) => ({
            ...j,
            show: true,
            msg: t("verificationCodeSentTitle"),
          }))
        : setSnackbar((j) => ({
            ...j,
            show: true,
            type: "error",
            msg: res.msg,
          }));
    };
    values.forgotStep = 1;
    Server(controller.Auth + action.Forgot).post(
      ToFormData(values),
      onComplete
    );
  };

  useEffect(() => {
    setValues(forgotVal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setForgotVal({ ...values });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <>
      <Form noValidate onSubmit={submitForm}>
        <Grid container className="p-15 pt-0" spacing={3}>
          <Grid item xs={12} className="tx-center mt-30 pb-30">
            <h2 className="fs-22 fw-6 tx-upp h gray-color">
              {t("verificationCode")}
            </h2>
            <div className="pos-relative d-flex j-center mt-5">
              <div className="border-bottom w-60" />
            </div>
          </Grid>
          <Grid item xs={12} className="mb-20">
            <Typography variant="p" className="font-18 gray-color">
              {t("frgtCodeSentTitle")} <strong>{values.email}</strong>
            </Typography>
          </Grid>
          <Grid item xs={12} className="tx-right">
            <Input
              type="number"
              label={t("enterVerificationCode")}
              name="verCode"
              value={values.verCode}
              onChange={handleInpChg}
              error={errors.verCode}
              className="input-primary w-100pr mb-10"
            />
            <span
              onClick={handleResend}
              className="font-18 gray-color hove-primary c-pointer"
            >
              {t("resendCode")}
            </span>
          </Grid>
          <Grid item xs={12} className="text-center">
            <Button
              loading={loading}
              type="submit"
              size="large"
              className="w-100pr mb-10"
            >
              {t("verify")}
            </Button>
            <Button
              onClick={() => setActiveStep(0)}
              size="large"
              variant="text"
              className="w-100pr"
            >
              {t("back")}
            </Button>
          </Grid>
        </Grid>
      </Form>
      {/* Alert  */}
      {/* <Alert alert={alert} setAlert={setAlert} /> */}
      <Snackbar {...{ snackbar, setSnackbar }} />
    </>
  );
};

export default VerifyFrgtCode;
